import { LoadableLazy } from '@confluence/loadable';

export const PublishModalKeyboardShortcuts = LoadableLazy({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-PublishModalKeyboardShortcuts" */ '../src/PublishModalKeyboardShortcuts.tsx'
			)
		).PublishModalKeyboardShortcuts;
	},
});
